
class ValidationService {
    rules() {
        return {
            requiredNumberWithZero: value => {
                if (!isNaN(parseFloat(value)) && value >= 0) return true;
                return 'Var vänlig och ange ett tal';
            },
            positiveInteger: value => {
                if (!isNaN(parseFloat(value)) && value > 0) return true;
                return 'Var vänlig och ange ett tal';
            },
            required: value => (value != null && typeof (value) != 'undefined' && value != "") || 'Var vänlig och ange',
            requiredSelection: value => {
                if (value == null || typeof (value) == 'undefined' || value === '') {
                    return 'Var vänlig och välj';
                }
                if (!isNaN(parseFloat(value)) && Number(value) <= 0) {
                    return 'Var vänlig och välj';
                }
                return true;
            },
            maxLength: max => value => (!value || value.length <= max) || `Ange högst ${max} tecken`,
            integer: value => (!isNaN(value) && parseInt(Number(value)) == value && !isNaN(parseInt(value, 10))) || 'Var vänlig och ange ett nummer',
            float: value => (!isNaN(value) && parseFloat(Number(value)) == value && !isNaN(parseInt(value, 10))) || 'Var vänlig och ange ett nummer',
            socialsecurityformat: value => {
                //const pattern = /^(\d{10}|\d{12}|\d{6}-\d{4}|\d{8}-\d{4}|\d{8} \d{4}|\d{6} \d{4})/g
                const pattern = /^(\d{8}$)/g
                return pattern.test(value) || 'Personnummer anges enligt formatet ÅÅÅÅMMDD'
            },

            
        }
    }
}

export default new ValidationService();
